import axios from 'axios'
import { getLocalStorage } from './storage'

const REQUEST_FROM_EXAM = 2

const instance = axios.create({
  baseURL: process.env.VUE_APP_HOST,
  headers: {
    'Content-Type': 'application/json'
  },
  data: {},
  timeout: 10000,
  withCredentials: true,
  loading: false,
  ignoreCode: false,
  useGateCenter: false
})

instance.interceptors.request.use((config) => {
  if (config.loading) window.showLoading()
  config.headers.authorization = getLocalStorage('exam_token')
  config.data.userId = getLocalStorage('exam_userId')
  config.data.requestFrom = REQUEST_FROM_EXAM
  if (config.useGateCenter) {
    config.baseURL = process.env.VUE_APP_GATE_CENTER_HOST
  }
  if (config.method === 'get' && config.data) {
    config.params = config.data
  }
  return config
}, (error) => {
  window.hideLoading()
  return Promise.reject(error)
})

instance.interceptors.response.use(async (response) => {
  if (response.config.loading) window.hideLoading()
  const resultCode = response.data.status
  if (response.config.ignoreCode || response.config.useGateCenter || resultCode === 10000) {
    return response.data
  } else {
    // 业务逻辑错误
    switch (resultCode) {
      case 20000:
      case 20001:
        window.hideLoading(true)
        await window.alert({
          type: 'error',
          title: '登录异常',
          content: '您当前的登录状态已失效，请重新登录'
        })
        window.localStorage.clear()
        window.location.reload()
        break
      default:
        window.toast.error(response.data.msg)
        break
    }
    return Promise.reject(response.data)
  }
}, (error) => {
  window.hideLoading()
  // 网络错误
  window.alert({
    type: 'error',
    title: '网络异常',
    content: '您的网络状态似乎存在问题，可能影响考试等功能的使用。请在网络状态良好的情况下使用重要功能！'
  })
  return Promise.reject(error)
})

export default instance
